import Form from "./Form";

const ChangePasswordPage = () => {
  return (
    <section className="h-full flex flex-col space-y-3 lg:space-y-5">
      <div className="flex-1">
        <Form />
      </div>
    </section>
  );
};

export default ChangePasswordPage;
